<template>
  <b-card no-body class="card-company-table">
    <b-card-header>
      <b-card-title>Most Popular Topics</b-card-title>
      <div class="d-flex align-items-center">
        <span v-if="spinnerPlayStop == true" style="margin-right: 25px">
          <b-spinner label="Loading..." />
        </span>
        <div style="width: 175px;">
      <!-- <label for="">Select Grade</label> -->
       {{ selectedGrade }}
      <v-select
        :options="grades"
        label="className"
        placeholder="Select Grade"
        :reduce="grade => grade._id"
        v-model="selectedGrade"
        @input="filterUser" 
      />
      </div>
      <div class="d-flex align-items-center">
        <date-range-picker
          ref="picker"
          :opens="'left'"
          :locale-data="{
            direction: 'ltr',
            format: 'yyyy-mm-dd',
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
            ],
            firstDay: 0,
          }"
          :minDate="'2019-01-01 00:00:00'"
          :maxDate="'2099-01-01 00:00:00'"
          :timePicker="false"
          :timePicker24Hour="true"
          :showWeekNumbers="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="GET_MOST_POPUPLAR_TOPIC"
          :linkedCalendars="true"
        >
        </date-range-picker>
        </div>
      </div>
      <b-card-text class="font-small-2 mr-25 mb-0"> </b-card-text>
      <!-- <span v-if="spinnerPlayStop == true" style="margin-right: 25px">
        <b-spinner label="Loading..." />
      </span> -->
      <span class="d-flex">
        <span class="font-weight-bolder" style="font-size: 12px;">{{ this.date + "  " }}</span>
        <span style="margin-left: 10px;font-size: 12px" class="font-weight-bolder">{{
          "    " + gradeName
        }}</span>
      </span>
    </b-card-header>

    <b-table
      :items="dashboardTable"
      responsive
      :fields="fields"
      class="mb-0"
      id="custom-table"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #cell(topic)="data">
        <div class="d-flex align-items-center">
          <div>
            {{ data.item.class }} / {{ data.item.subject }} /
            <div class="font-weight-bolder">
              {{ data.item.topic }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(time)="data">
        <div class="d-flex align-items-center">
          <div>
            <div class="font-weight-bolder">
              {{ data.item.Time }}
            </div>
          </div>
        </div>
      </template>
    </b-table>
    <div style="display: flex; flex-direction: row-reverse">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="custom-table"
        size="sm"
      ></b-pagination>
    </div>
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
  BTable,
  BAvatar,
  BImg,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BMedia,
  BMediaAside,
  BMediaBody,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormInput,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { methods } from "vue-echarts";
import axios from "axios";
import vSelect from "vue-select";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import * as Helpers from "../../Helpers";

export default {
  components: {
    vSelect,
    BButton,
    BCard,
    BTable,
    BPagination,
    BCardHeader,
    BCardTitle,
    DateRangePicker,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BImg,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BAvatar,
    BFormInput,
    Helpers,
  },
  directives: {
    Ripple,
  },
  // props: {
  //   sendDatesPropsToAllComponent: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  props: {
    sendDatesPropsToAllComponent: {
      type: Object,
      required: true,
    },
  },
  watch: {
  // sendDatesPropsToAllComponent: {
  //   handler(val) {
  //     console.log("Watcher Triggered", val);
  //     if (val.date) {
  //       this.selected = val.gradeId;
  //       if (this.selected.className === "All") {
  //         this.gradeName = "All -> All Grades";
  //       }

  //       const first = val.date.startDate.toLocaleDateString("en-US", {
  //         year: "numeric",
  //         month: "2-digit",
  //         day: "2-digit",
  //       });

  //       const last = val.date.endDate.toLocaleDateString("en-US", {
  //         year: "numeric",
  //         month: "2-digit",
  //         day: "2-digit",
  //       });

  //       this.date = `${first} - ${last}`.replaceAll("/", "-");
  //       this.dateRange = val.date;
  //       this.GET_MOST_POPUPLAR_TOPIC(val.date);
  //     } else {
  //       this.GET_MOST_POPUPLAR_TOPIC(val);
  //     }
  //   },
  //   deep: true,
  //   immediate: true,
  // },


    sendDatesPropsToAllComponent(val) {
      console.log("sendDatesPropsToAllComponent changed", val);
      if (this.sendDatesPropsToAllComponent.date) {
        this.selected = this.sendDatesPropsToAllComponent.gradeId;
        if (this.selected.className == "All") {
          this.gradeName = "All -> All Grades";
        }
        let first =
          this.sendDatesPropsToAllComponent.date.startDate.toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }
          );

        let last =
          this.sendDatesPropsToAllComponent.date.endDate.toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }
          );
        this.date = first + " - " + last;
        this.date = this.date.replaceAll("/", "-");
        this.dateRange = this.sendDatesPropsToAllComponent.date;
        this.GET_MOST_POPUPLAR_TOPIC(this.sendDatesPropsToAllComponent.date);
      } else {
        this.GET_MOST_POPUPLAR_TOPIC(this.sendDatesPropsToAllComponent);
      }
    },
  selectedGrade(newVal) {
    if (newVal && this.dateFilter.startDate && this.dateFilter.endDate) {
      this.GET_MOST_POPUPLAR_TOPIC(); 
    }
  },

  },
  data() {
    return {
      grades: [],       
      selectedGrade: null,
      spinnerPlayStop: true,
      perPage: 10,
      currentPage: 1,
      selected: "",
      date: "",
      gradeName: "All -> All Grades",
      // dateRange: {},
      dateFilter: {
        startDate: null,
        endDate: null
      },
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      rangePicker: ["2022-05-01", "2022-05-10"],
      Picker: "2022-05-01 to 2022-05-10",
      fields: [
        { key: "topic", label: "TOPIC" },
        { key: "time", label: "TIME" },
      ],

      dashboardTable: [],
      Helpers,
    };
  },
  computed: {
    rows() {
      return this.dashboardTable.length;
    },
  },
  created(){
    console.log('getTodayDates',this.Helpers.getTodayDates());
    this.dateRange.startDate = this.Helpers.getTodayDates().startDate;
    this.dateRange.endDate = this.Helpers.getTodayDates().endDate;
    this.GET_MOST_POPUPLAR_TOPIC(this.Helpers.getTodayDates());
    this.fetchGrades();
  },

  methods: {
    // filterUser(value) {
    //   console.log('testing')
    //   this.GET_MOST_POPUPLAR_TOPIC(this.Helpers.getTodayDates());
    // },
    filterUser(value) {
      console.log('Grade selected:', value);
      const start = this.dateRange.startDate;
      const end = this.dateRange.endDate;

      this.GET_MOST_POPUPLAR_TOPIC({
        startDate: start,
        endDate: end,
      });
    },

  async fetchGrades() {
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + '/grade/get-all',
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            }
          }
        );
        console.log(response.data.grades);
        this.grades= response.data.grades;
      } catch (error) {
        console.error('Error fetching grades:', error);
      }
    },
    GET_MOST_POPUPLAR_TOPIC(value) {
  this.spinnerPlayStop = true;

  // if (!value?.startDate || !value?.endDate) {
  //   console.warn('Date range missing');
  //   this.spinnerPlayStop = false;
  //   return;
  // }
  // let startDateObj, endDateObj;

if (value?.startDate && value?.endDate) {
  startDateObj = value.startDate;
  endDateObj = value.endDate;
} else {
  startDateObj = this.dateRange.startDate;
  endDateObj = this.dateRange.endDate;
}

  let startDateObj = value.startDate;
  let endDateObj = value.endDate;

  // Format startDate
  let startMonth = startDateObj.getMonth() + 1;
  let startDay = startDateObj.getDate();
  let startYear = startDateObj.getFullYear();
  if (startDay < 10) startDay = '0' + startDay;
  if (startMonth < 10) startMonth = '0' + startMonth;
  const formattedStart = `${startYear}-${startMonth}-${startDay}`;

  // Format endDate
  let endMonth = endDateObj.getMonth() + 1;
  let endDay = endDateObj.getDate();
  let endYear = endDateObj.getFullYear();
  if (endDay < 10) endDay = '0' + endDay;
  if (endMonth < 10) endMonth = '0' + endMonth;
  const formattedEnd = `${endYear}-${endMonth}-${endDay}`;

  // Construct datetime
  let datetime = {
    gradeId: this.selectedGrade
  };

  if (formattedStart === formattedEnd) {
    datetime.date = formattedStart;
  } else {
    datetime.date = `${formattedStart} to ${formattedEnd}`;
  }

  axios
    .post(process.env.VUE_APP_API_URL + "/most-popular/topic", datetime, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("_t"),
      },
    })
    .then((response) => {
      this.dashboardTable = response.data;
      this.spinnerPlayStop = false;
    })
    .catch((error) => {
      console.error("Topic fetch error:", error);
      this.spinnerPlayStop = false;
    });
},

    // GET_MOST_POPUPLAR_TOPIC(value) {
    //   this.spinnerPlayStop = true;
    //   var startDate = value.startDate;
    //   var endDate = value.endDate;
    //   var month = startDate.getMonth() + 1;
    //   var day = startDate.getDate();
    //   var year = startDate.getFullYear();
    //   if (day >= 10) {
    //   } else {
    //     day = "0" + day;
    //   }
    //   if (month >= 10) {
    //   } else {
    //     month = "0" + month;
    //   }
    //   var startDate = year + "-" + month + "-" + day;
    //   var month = endDate.getMonth() + 1;
    //   var day = endDate.getDate();
    //   var year = endDate.getFullYear();
    //   if (day >= 10) {
    //   } else {
    //     day = "0" + day;
    //   }
    //   if (month >= 10) {
    //   } else {
    //     month = "0" + month;
    //   }
    //   var lastDate = year + "-" + month + "-" + day;
    //   if (startDate == lastDate) {
    //     var datetime = {
    //       date: `${startDate}`,
    //       // gradeId: this.selected._id,
    //       gradeId: this.selectedGrade, 

    //     };
    //   } else {
    //     var datetime = {
    //       date: `${startDate + " " + "to" + " " + lastDate}`,
    //       // gradeId: this.selected._id,
    //       gradeId: this.selectedGrade, 


    //     };
    //   }

    //   // var startDate = this.Helpers.changeDateFormat(this.dateRange.startDate);
    //   // var endDate = this.Helpers.changeDateFormat(this.dateRange.endDate);

    //   // const datetime = {
    //   //   startDate: startDate,
    //   //   endDate: endDate,
    //   //   gradeId: this.selectedGrade, 
    //   // };
    //   axios
    //     .post(process.env.VUE_APP_API_URL + "/most-popular/topic", datetime, {
    //       headers: {
    //         Authorization: "Bearer " + localStorage.getItem("_t"),
    //       },
    //     })
    //     .then((response) => {
    //       this.dashboardTable = response.data;
    //       this.spinnerPlayStop = false;
    //     });
    // },
    exportdata: function () {
      axios({
        url: process.env.VUE_APP_API_URL + "/exportalldata",
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "data.json");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
  },
};
</script>

<style>
</style>
